import {useState} from 'react';
import {Button, ButtonProps} from '@mantine/core';
import {AiOutlineSearch} from 'react-icons/ai';
import {AnalyzeRepositoryDrawer} from '../drawers/AnalyzeRepositoryDrawer';

interface AnalyzeRepositoryButtonProps extends ButtonProps {
    repositoryName?: string;
}

export const AnalyzeRepositoryButton = ({repositoryName, ...props}: AnalyzeRepositoryButtonProps) => {

    const [drawerOpened, setDrawerOpened] = useState(false);

    if (drawerOpened) {
        return (
            <AnalyzeRepositoryDrawer
                opened={drawerOpened}
                onClose={() => setDrawerOpened(false)}
                repositoryName={repositoryName}
            />
        );
    }

    return (
        <Button
            leftSection={<AiOutlineSearch/>}
            onClick={() => setDrawerOpened(true)}
            {...props}
        >
            Analyze Repository
        </Button>
    );
};
